module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_60_Active@1x-f82a3b8bc0b6be76371c920dc6749a68.png";